var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',{attrs:{"two-line":"","subheader":""}},_vm._l((_vm.spieler),function(entry){return _c('ModRaidSpielerListEntryComp',{key:entry.id,attrs:{"spieler":entry,"raid":_vm.raid},on:{"refresh":_vm.refresh}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }